import actions from './actions';

export default {
  actions,

  state: () => ({
    allCategories: null,
  }),
};
